import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import apiClient from "../../../config/apiClient";
import { Helmet } from "react-helmet";
// ✅ BlockNote -> plain text (safe)
const iconMap = {
  document: "📘",
  check: "✔️",
  users: "👥",
  plug: "🔌",
  card: "💳",
  lock: "🔒",
  rocket: "🚀",
  bulb: "💡",
  settings: "⚙️",
  chart: "📊",
  target: "🎯",
  star: "🌟",
  task: "✅",
  time: "⏰",
  security: "🔐",
  star2: "⭐",
  cap: "🎓",
  // Add more as needed
};

function blockNoteJsonToText(input) {
  try {
    const blocks = typeof input === "string" ? JSON.parse(input) : input;
    if (!Array.isArray(blocks)) return "";

    const out = [];

    const walk = (node) => {
      if (!node) return;

      if (typeof node.text === "string" && node.text.trim()) {
        out.push(node.text.trim());
      }

      if (Array.isArray(node.content)) node.content.forEach(walk);
      if (Array.isArray(node.children)) node.children.forEach(walk);
    };

    blocks.forEach((b) => {
      if (Array.isArray(b.content)) b.content.forEach(walk);
      if (Array.isArray(b.children)) b.children.forEach(walk);
    });

    return out.join(" ").replace(/\s+/g, " ").trim();
  } catch {
    return "";
  }
}

// ✅ make a short snippet from BlockNote JSON
function snippetFromBlockNote(input, max = 90) {
  const text = blockNoteJsonToText(input);
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 1) + "…" : text;
}

export default function DocsHomeLinear() {
  const navigate = useNavigate();
  const { id } = useParams();
  const outlet = useOutletContext() || {};
  // Uncomment this line first (line 46)
  const outletCategories = outlet.categories || [];

  // Then use it in useMemo
  const categories = useMemo(() => outletCategories, [outletCategories]);
  const loading = !!outlet.loading;

  const [popularPages, setPopularPages] = useState([]);
  const [basicPages, setBasicPages] = useState([]);
  const [basicLoading, setBasicLoading] = useState(false);
  const [popularLoading, setPopularLoading] = useState(false);
  useEffect(() => {
    const fetchPopularPages = async () => {
      setPopularLoading(true);
      try {
        // 👇 Tumhara diya hua API endpoint
        const response = await apiClient.get("/pages/popular");
        // console.log("Popular pages response:", response.data);

        // API response structure ke hisaab se data nikaalo
        const popularData = response.data?.data || response.data || [];

        const pagewithSlug = popularData.map((page) => ({
          ...page,
          slug: page.slug,
        }));
        // console.log("Page with slug", pagewithSlug);
        setPopularPages(pagewithSlug);
      } catch (error) {
        console.error("Error fetching popular pages:", error);
        // Error par empty array
        setPopularPages([]);
      } finally {
        setPopularLoading(false);
      }
    };

    fetchPopularPages();
  }, []); // 👈 Sirf ek baar run hoga component mount par
  useEffect(() => {
    const fetchBasicsPages = async () => {
      setBasicLoading(true);
      try {
        // 👇 Tumhara diya hua API endpoint
        const response = await apiClient.get("/pages/basic");
        // console.log("Popular pages response:", response.data);

        // API response structure ke hisaab se data nikaalo
        const basicData = response.data?.data || response.data || [];
        setBasicPages(basicData);
      } catch (error) {
        console.error("Error fetching popular pages:", error);
        // Error par empty array
        setBasicPages([]);
      } finally {
        setBasicLoading(false);
      }
    };

    fetchBasicsPages();
  }, []);
  // const allPages = useMemo(() => {
  //   return categories.flatMap((c) =>
  //     (c.pages || []).map((p) => ({
  //       ...p,
  //       categoryName: c.name,
  //       categoryIcon: c.icon,
  //       _snippet: p.description
  //         ? snippetFromBlockNote(p.description, 95)
  //         : p.content
  //           ? snippetFromBlockNote(p.content, 95)
  //           : "",
  //     })),
  //   );
  // }, [categories]);
  const allPages = useMemo(() => {
    return categories.flatMap((group) =>
      (group.categories || []).flatMap((cat) =>
        (cat.pages || []).map((p) => ({
          ...p,
          heading: p.heading, // ✅ ADD THIS
          categoryName: cat.name,
          categoryIcon: cat.icon,
          groupName: group.name,
          groupIcon: group.icon, // ✅ FIX
          _snippet: p.description
            ? snippetFromBlockNote(p.description, 95)
            : p.content
              ? snippetFromBlockNote(p.content, 95)
              : "",
        })),
      ),
    );
  }, [categories]);
  // console.log("categories:", categories);
  // console.log("allPages:", allPages);

  // const popular = useMemo(() => {
  //   return popularPages
  //     .map((popularPage) => {
  //       let foundGroup = null;
  //       let foundCategory = null;

  //       for (const group of categories) {
  //         for (const cat of group.categories || []) {
  //           const match = (cat.pages || []).find(
  //             (p) => String(p.id) === String(popularPage.id),
  //           );

  //           if (match) {
  //             foundGroup = group;
  //             foundCategory = cat;
  //             break;
  //           }
  //         }
  //         if (foundGroup) break;
  //       }

  //       return {
  //         ...popularPage,
  //         heading: popularPage.heading || popularPage.title,

  //         // ✅ IMPORTANT FIX
  //         groupName: foundGroup?.name || "Docs",
  //         groupIcon: foundGroup?.icon || "📄",

  //         categoryName: foundCategory?.name || "",

  //         _snippet: popularPage.description
  //           ? snippetFromBlockNote(popularPage.description, 95)
  //           : popularPage.content
  //             ? snippetFromBlockNote(popularPage.content, 95)
  //             : "",
  //       };
  //     })
  //     .slice(0, 4);
  // }, [popularPages, categories]);

  // const basics = useMemo(() => {
  //   // Popular pages ke IDs nikaalo
  //   const popularIds = new Set(popular.map((p) => p.id));

  //   // Baaki sab pages jo popular nahi hain
  //   return allPages.filter((p) => !popularIds.has(p.id)).slice(0, 8); // Max 8 basics
  // }, [allPages, popular]);
  // const popular = useMemo(() => {
  //   return allPages.filter((p) => p.is_popular).slice(0, 4);
  // }, [allPages]);
  // const popular = useMemo(() => {
  //   return popularPages.slice(0, 4);
  // }, [popularPages]);
  function findMeta(pageId, categories) {
    for (const group of categories) {
      for (const cat of group.categories || []) {
        const match = (cat.pages || []).find(
          (p) => String(p.id) === String(pageId),
        );

        if (match) {
          return {
            groupName: group.name,
            groupIcon: group.icon,
            categoryName: cat.name,
          };
        }
      }
    }

    return {
      groupName: "Docs",
      groupIcon: "📄",
      categoryName: "",
    };
  }
  const popular = useMemo(() => {
    return popularPages
      .map((page) => {
        const meta = findMeta(page.id, categories);

        return {
          ...page,
          ...meta,
          _snippet: page.description
            ? snippetFromBlockNote(page.description, 95)
            : "",
        };
      })
      .slice(0, 4);
  }, [popularPages, categories]);
  // const popular = useMemo(() => {
  //   return popularPages
  //     .map((page) => {
  //       let foundGroup = null;
  //       let foundCategory = null;

  //       for (const group of categories) {
  //         for (const cat of group.categories || []) {
  //           const match = (cat.pages || []).find(
  //             (p) => String(p.id) === String(page.id),
  //           );

  //           if (match) {
  //             foundGroup = group;
  //             foundCategory = cat;
  //             break;
  //           }
  //         }
  //         if (foundGroup) break;
  //       }

  //       return {
  //         ...page,
  //         groupName: foundGroup?.name || "Docs",
  //         groupIcon: foundGroup?.icon || "📄",
  //         categoryName: foundCategory?.name || "",
  //         _snippet: page.description
  //           ? snippetFromBlockNote(page.description, 95)
  //           : "",
  //       };
  //     })
  //     .slice(0, 4);
  // }, [popularPages, categories]);
  // const basics = useMemo(() => {
  //   // return allPages.filter((p) => p.is_basic).slice(0, 8);
  //   return basicPages.slice(0, 8);
  // }, [basicPages]);
  const basics = useMemo(() => {
    return basicPages
      .map((page) => {
        let foundGroup = null;
        let foundCategory = null;

        for (const group of categories) {
          for (const cat of group.categories || []) {
            const match = (cat.pages || []).find(
              (p) => String(p.id) === String(page.id),
            );

            if (match) {
              foundGroup = group;
              foundCategory = cat;
              break;
            }
          }
          if (foundGroup) break;
        }

        return {
          ...page,
          groupName: foundGroup?.name || "Docs",
          groupIcon: foundGroup?.icon || "📄",
          categoryName: foundCategory?.name || "",
          _snippet: page.description
            ? snippetFromBlockNote(page.description, 95)
            : "",
        };
      })
      .slice(0, 8);
  }, [basicPages, categories]);
  // const popular = useMemo(() => allPages.slice(0, 4), [allPages]);
  // const basics = useMemo(() => allPages.slice(4, 12), [allPages]);

  // const openPage = (id) => (
  //   navigate(`/docs/${id}`),
  //   console.log("first", id)
  // );
  // const openPage = (id) => {navigate("/docs", { state: { id } })};
  const openPage = (page) => {
    navigate(`/docs/${page.slug}`, {
      state: { id: page.id },
    });
  };
  return (
    <>
      <Helmet>
        <title>Simplifyte Academy</title>
      </Helmet>
      <div className="Simplifyte_Docs_Main_Class">
        <h1 className="font-semibold tracking-tight text-gray-900 Simplifyte_Docs">
          Simplifyte Docs
        </h1>
        <p className="mt-2 text-gray-600 max-w-2xl Simplifyte_Docs_Para">
          Get an overview of Simplifyte’s features, workflows, integrations, and
          how to use them.
        </p>

        <SectionTitle title="Popular" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {loading
            ? Array.from({ length: 4 }).map((_, i) => <CardSkeleton key={i} />)
            : popular.map((p) => (
                <DocCard
                  key={p.id}
                  // icon={p.icon || "📄"}
                  icon={p.icon}
                  title={p.title || "Untitled"}
                  description={p._snippet || `${p.categoryName || "Docs"}`}
                  heading={p.heading}
                  group_name={p.groupName}
                  group_icon={p.groupIcon} // ✅ ADD
                  onClick={() => openPage(p)}
                />
              ))}
        </div>

        <SectionTitle title="Simplifyte basics" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)
            : basics.map((p) => (
                <DocCard
                  key={p.id}
                  icon={p.icon || "📄"}
                  title={p.title || "Untitled"}
                  description={p._snippet || `${p.categoryName || "Docs"}`}
                  group_name={p.groupName} // ✅ FIXED
                  group_icon={p.groupIcon} // ✅ ADD
                  heading={p.heading}
                  onClick={() => openPage(p)}
                />
              ))}
        </div>
      </div>
    </>
  );
}

/* ===================== SMALL COMPONENTS ===================== */

function SectionTitle({ title }) {
  return <h2 className="Simplifyte_Docs_Title text-gray-700">{title}</h2>;
}

export function DocCard({
  icon,
  title,
  description,
  onClick,
  group_name,
  heading,
  group_icon,
}) {
  return (
    <button
      onClick={onClick}
      className="text-left rounded-2xl border border-gray-200 !bg-[#ECECED]/10
                 hover:bg-gray-50 transition overflow-hidden hover:shadow"
      //  shadow-sm
      type="button"
    >
      {/* <div className="h-24 p-5 Simplifyte_Docs_DocCard flex items-start ">
        <div className="w-10 h-10 rounded-xl bg-gray-100 border border-gray-200 flex items-center justify-center">
          <span className="text-lg">{icon}</span>
        </div>
      </div> */}
      <div className="IconWrap">
        <div className="IconInner">
          <div className="IconBox">
            <span className="IconText">{group_icon}</span>
          </div>
          {group_name && (
            <div className="GroupBadge flex items-center gap-1 uppercase text-[#6F6E77]">
              {/* <span> {iconMap[group_icon?.toLowerCase?.()] || group_icon}</span> */}
              <span>{group_name}</span>
            </div>
          )}
          {/* {group_name && (
            <div className="GroupBadge">{group_name.toUpperCase()}</div>
          )} */}
          {/* {heading && <div className="DocCard_Heading">{heading}</div>} */}
          {/* {console.log("adhadadhdhasdhadhadad", heading)} */}
        </div>
      </div>
      <div className="px-5 py-4 border-t border-gray-200">
        <div className="text-gray-900 font-semibold">{title}</div>
        <div className="mt-1 text-sm line-clamp-2 text-[#6F6E77]">
          {description}
        </div>
      </div>
    </button>
  );
}

function CardSkeleton() {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden animate-pulse shadow-sm">
      <div className="h-24 p-5" />
      <div className="px-5 py-4 border-t border-gray-200">
        <div className="h-4 w-2/3 bg-gray-200 rounded" />
        <div className="mt-2 h-3 w-5/6 bg-gray-200 rounded" />
      </div>
    </div>
  );
}
